export default __webpack_public_path__ + "static/media/gamestack-login-large.78522e7e.jpg";